import React from 'react';
import styled from 'astroturf/react';
import DownloadIcon from 'js/design_system/icons/arrow_downward.svg';
import LinkIcon from 'js/design_system/icons/arrow_right.svg';
import { Button } from 'js/design_system/Button';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Modal } from 'js/design_system/Modal';
import { Attachment } from 'js/liswp/build_vu/Attachment';
import { PaperUpdateUnlinked } from '../shared/types';
import { Props as ImpressionProps } from 'js/utils/impressions/ImpressionWatcher';
import { ImpressionWatcher } from 'js/utils/impressions';
import _ReaderModal from "Reader-ReaderModal.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Reader/Reader.tsx?styleId=ReaderModal";
import _AttachmentPanel from "Reader-AttachmentPanel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Reader/Reader.tsx?styleId=AttachmentPanel";
import _ContentsWrapper from "Reader-ContentsWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Reader/Reader.tsx?styleId=ContentsWrapper";
import _AttachmentWrapper from "Reader-AttachmentWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Reader/Reader.tsx?styleId=AttachmentWrapper";
import _ButtonRow from "Reader-ButtonRow.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Reader/Reader.tsx?styleId=ButtonRow";


const ReaderModal = /*#__PURE__*/styled(Modal, null, {
  displayName: "ReaderModal",
  styles: _ReaderModal
});

const AttachmentPanel = /*#__PURE__*/styled("div", null, {
  displayName: "AttachmentPanel",
  styles: _AttachmentPanel
});

const ContentsWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ContentsWrapper",
  styles: _ContentsWrapper
});

const AttachmentWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "AttachmentWrapper",
  styles: _AttachmentWrapper
});

const ButtonRow = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonRow",
  styles: _ButtonRow
});

type ButtonRowProps = {
  work: PaperUpdateUnlinked;
  impressionProps?: ImpressionProps;
  onDownload?: () => void;
  source: string;
};

export const DefaultButtonRow = ({
  work,
  impressionProps,
  onDownload,
  source,
}: ButtonRowProps) => (
  <ButtonRow>
    <ImpressionWatcher {...impressionProps} source={`${source}_download`}>
      <Button icon={<DownloadIcon />} secondary onClick={onDownload}>
        Download
      </Button>
    </ImpressionWatcher>
    <ImpressionWatcher {...impressionProps} source={`${source}_related`}>
      <ButtonLink href={work.url} target="_blank" iconRight={<LinkIcon />}>
        View Related Papers
      </ButtonLink>
    </ImpressionWatcher>
  </ButtonRow>
);

export type ReaderProps = {
  className?: string;
  work: PaperUpdateUnlinked;
  open: boolean;
  impressionProps?: ImpressionProps;
  onDownload?: () => void;
  onClose?: () => void;
  buttonRow?: React.ReactElement;
  sidebar?: React.ReactElement;
  fullWidth?: boolean;
};

export const Reader: React.FC<ReaderProps> = ({
  className,
  work,
  open,
  impressionProps,
  onDownload,
  onClose = () => null,
  buttonRow = React.createElement(DefaultButtonRow),
  sidebar,
  fullWidth = false,
}) => {
  const baseSource = impressionProps?.source;
  const source = (baseSource ? `${baseSource}_` : '') + 'reader';

  return (
    <ReaderModal
      className={className}
      title={work.title}
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
    >
      <ContentsWrapper>
        <AttachmentWrapper>
          <AttachmentPanel>
            {work.attachment?.id && (
              <Attachment
                key={work.attachment.id.toString()}
                shown={open}
                attachmentId={work.attachment.id.toString()}
              />
            )}
          </AttachmentPanel>
          {React.cloneElement(buttonRow, {
            ...buttonRow.props,
            work,
            impressionProps,
            onDownload,
            source,
          })}
        </AttachmentWrapper>
        {sidebar}
      </ContentsWrapper>
    </ReaderModal>
  );
};
